<template>
    <div class="main_d" v-lazy:background-image="{src: lazyImg.bgc2}">
        <div class="content">
            <!-- 成绩页--start -->
            <div class="grade">
                <div class="grade_t" v-lazy:background-image="{src: lazyImg.titleBig4}"></div>
                <div class="grade_b">
                    <div class="grade_bl fl-ai-jc" v-lazy:background-image="{src: lazyImg.effectBgc}">
                        <img v-lazy="detailInfo.picUrl" :key="detailInfo.picUrl" alt="">
                    </div>
                    <div class="grade_bc">
                        <h5>{{detailInfo.name || ""}}</h5>
                        <em>{{detailInfo.priceRange || ""}}</em>
                        <p>测试时间 {{detailInfo.examTime || ""}}</p>
                        <p>测试版本 {{detailInfo.modelName || ""}}</p>
                        <p>ICT300测试总分</p>
                        <h6><em>{{detailInfo.totalScore || ""}}</em>分</h6>
                    </div>
                    <div class="grade_br">
                        <p>本次测试采用ICT300评测标准
                            <router-link :to="{ path: '/inside'}" tag="a"><i></i></router-link>
                        </p>
                        <div class="grade_pic_box">
                            <div class="grade_pic" v-if="detailInfo.moduleList">
                                <proChart :moduleList="detailInfo.moduleList"></proChart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 成绩页--end -->

            <!-- 智能配置一览表--start -->
            <div class="configure" v-if="detailInfo.hardWareList && detailInfo.hardWareList.length>0">
                <div class="configure_t"></div>
                <div class="configure_b" v-lazy:background-image="{src: lazyImg.border6}">
                    <div class="configure_show">
                        <div class="configure_box">
                            <div v-for="(item,index) in detailInfo.hardWareList" :key="index" class="configure_item fl-ai-jcb">
                                <div class="configure_item_l">
                                    <img v-lazy="item.picUrl" :key="item.picUrl" v-if="item.picUrl">
                                    <i>{{item.name || ""}}</i>
                                </div>
                                <i>{{item.content || ""}}</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 智能配置一览表--end -->

            <!-- 分项测试得分--start -->
            <div class="module">
                <div class="module_t"></div>
                <tabModel :tabList="detailInfo.moduleList" :TabSelIndex="moduleSelIndex" showName="name" @changeTab="changeTab"></tabModel>
                <!-- <div class="module_bigvideo" v-lazy:background-image="{src: lazyImg.border7}" v-if="detailInfo && detailInfo.moduleList && detailInfo.moduleList[moduleSelIndex]">
                    <div class="bigvideo_bgc" v-lazy:background-image="{src: detailInfo.moduleList[moduleSelIndex].videoUrl?lazyImg.border8:lazyImg.noplaybg}">
                        <i>暂无{{detailInfo.moduleList[moduleSelIndex].name || ""}}测试解说视频</i>
                    </div>
                    <div class="bigvideo_box">
                        <video autoplay loop :src="detailInfo.moduleList[moduleSelIndex].videoUrl" :poster="detailInfo.moduleList[moduleSelIndex].coverUrl"></video>
                        <div class="bigvideo_control" @click="controlStop">
                            <i v-show="!videoPlay && detailInfo.moduleList[moduleSelIndex].videoUrl" @click.stop="controlPlay"></i>
                        </div>
                    </div>
                </div> -->
                <div class="module_score" v-if="detailInfo && detailInfo.moduleList && detailInfo.moduleList[moduleSelIndex]">
                    <div class="main_score fl-ai-jcb">
                        <div class="left_name">{{detailInfo.moduleList[moduleSelIndex].name || ""}}</div>
                        <div class="right_score"><i>{{detailInfo.moduleList[moduleSelIndex].score || "0"}}</i>/{{detailInfo.moduleList[moduleSelIndex].fullScore || "0"}}分</div>
                    </div>
                    <div class="sub_score">
                        <el-collapse v-model="activeName" accordion>
                            <div v-for="(item,index) in detailInfo.moduleList[moduleSelIndex].itemList" :key="index" class="sub_score_box">
                                <div class="sub_allscore"><i>{{item.score || "0"}}</i>/{{item.fullScore || "0"}}</div>
                                <el-collapse-item :title="item.name" :name="index+1">
                                    <div v-for="(item2,index2) in item.detailList" :key="index2" class="sub_score_item fl-ai-jcb">
                                        <div class="left_name">{{item2.name || "0"}}</div>
                                        <div class="right_score"><i>{{item2.score || "0"}}</i>/{{item2.fullScore || "0"}}分</div>
                                    </div>
                                </el-collapse-item>
                            </div>
                        </el-collapse>
                    </div>
                </div>
            </div>
            <!-- 分项测试得分--end -->

             <div class="bottom_flag">—— 页面已经到底啦 ——</div>
        </div>
    </div>

</template>
<script>
import "@/tool/jquery.cookie.js"
import tabModel from "@/components/tab"
import proChart from "@/components/proChart"
import commonjs from "@/common/common.js"
import { getDomain } from '../pc.config';
export default {
    components: {
        tabModel,proChart
    },
    data() {
        return {
            lazyImg:{
                bgc2:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/bgc2.jpg",
                border6:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border6.png",
                border7:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border7.png",
                border8:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/border8.png",
                noplaybg: "https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/noplaybg.png",
                effectBgc: "https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/effect_bgc.png",
                titleBig4:"https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/title_big4.png",
            },
            isShowPage:false,
            // issue:"",
            evaluationId:0,
            serialId:"",
            videoPlay:false,
            activeName:0,
            moduleSelIndex:0,
            detailInfo:{},
            evaluationIdRes:''
        }
    },
    mounted() {
        // 获取当前时间
        this.evaluationId = this.$route.query.evaluationId
        this.moduleSelIndex = this.$route.query.moduleIndex
        // 获取数据
        this.getEvaluationDetail()
    },
    methods: {
        // 获取测评报告详情数据
        getEvaluationDetail(){
            let {evaluationId}=this;
            let url = getDomain('getEvaluationDetail');
            // console.log('${url}/detail${evaluationId}.json==',`${url}/detail${evaluationId}.json`);
            let params = {
                url: `${url}/detail${evaluationId}.json`,
                method: 'get',
            };
            this.$axios(params).then((res) => {
                this.detailInfo = res;
                this.isShowPage = true;
                
                if(evaluationId != this.detailInfo.evaluationId){
                    this.$router.push({path:'/'});
                }
                
                this.$nextTick(()=>{
                    var video = $(".bigvideo_box video")[0];
                    // video.addEventListener("playing",()=>{
                    //     this.videoPlay = true;
                    // })
                    // video.addEventListener("pause",()=>{
                    //     this.videoPlay = false;
                    // })
                })
            }).catch(err => {
                alert(err)
            });
        },
        changeTab(index){
            this.moduleSelIndex = index;
            this.activeName = 0;
        },
        // controlPlay(){
        //     var video = $(".bigvideo_box video")[0];
        //     if(video.paused){
        //         video.play();
        //         this.videoPlay = true;
        //     }
        // },
        // controlStop(){
        //     var video = $(".bigvideo_box video")[0];
        //     if(!video.paused){
        //         video.pause();
        //         this.videoPlay = false;
        //     }
        // },
    }
}
</script>
<style lang="less">
  .main_d{
    padding-bottom: 50px;
    margin-bottom: 40px;
    background-color: #06143c;
    background-position: center top;
    background-repeat: no-repeat;
    min-width: 1180px;
    min-height: 1000px;
    width: 100%;
    color: #d8fcff;
    .content{
        max-width: 1180px;
        min-width: 960px;
        margin:0 auto;
        .grade{
            padding-top: 120px;
            .grade_t{
                background-position: center top;
                background-repeat: no-repeat;
                width:571px;
                height: 89px;
                margin:0 auto 50px;
            }
            .grade_b{
                display: flex;
                .grade_bl{
                    width: 40%;
                    background-size: 100%;
                    background-position: center top;
                    background-repeat: no-repeat;
                    img{
                        width: 80%;
                        margin-bottom: 90px;
                    }
                }
                .grade_bc{
                    width: 30%;
                    h5{
                        font-size: 28px;
                        // line-height: 50px;
                        height: 50px;
                    }
                    em{
                        font-size: 18px;
                        line-height: 35px;
                        height: 35px;
                    }
                    p{
                        font-size: 16px;
                        color:#28b4c3;
                        line-height: 35px;
                        height: 35px;
                    }
                    h6{
                        font-size: 40px;
                        line-height: 120px;
                        height: 120px;
                        em{
                            font-size: 88px;
                        }
                    }
                }
                .grade_br{
                    width: 30%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    p{
                        color: #28b4c3;
                        line-height: 30px;
                        a{
                            cursor: pointer;
                            i{
                                background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/wenhao.png) no-repeat center;
                                width:16px;
                                height: 16px; 
                                position: relative;
                                top: 2px;
                            }
                        }
                    }
                    .grade_pic_box{
                        position: relative;
                        width: 350px;
                        height: 280px;
                        margin-top: 25px;
                        .grade_pic{
                            position: absolute;
                        }
                    }
                }
            }
        }
        .configure{
            .configure_t{
                background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/subtitle1.png) no-repeat center;
                width:257px;
                height: 62px;
                margin:50px auto 30px;
            }
            .configure_b{
                background-position: center top;
                background-repeat: no-repeat;
                width:1180px;
                height: 202px;
                margin:0 auto;
                overflow: hidden;
                padding: 20px 0;
                box-sizing: border-box;
                .configure_show{
                    padding: 0 20px;
                    width: 1171px;
                    height: 161px;
                    overflow-y: auto;
                    overflow-x: hidden;
                    .happy-scroll{
                        width: 101%;
                        height: 91%;
                    }
                    .configure_box{
                        width: 1280px;
                        padding: 11px 25px;
                        display: flex;
                        flex-wrap: wrap;
                        // overflow: auto;
                        // height: 170px;
                        .configure_item{
                            width: 32%;
                            padding-right: 80px;
                            line-height: 22px;
                            height: 46px;
                            box-sizing: border-box;
                            .configure_item_l{
                                img{
                                    margin-right: 10px;
                                    height: 30px;
                                    margin-top: 10px;
                                }
                            }
                        }
                    }
                }
                
            }
        }
        .module{
            .module_t{
                background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/subtitle2.png) no-repeat center;
                width:257px;
                height: 62px;
                margin: 100px auto 50px;
            }
            .module_bigvideo{
                margin:0 auto;
                background-position: center top;
                background-repeat: no-repeat;
                width:1191px;
                height: 668px;
                position: relative;
                .bigvideo_bgc{
                    background-position: center top;
                    background-repeat: no-repeat;
                    width:1191px;
                    height: 668px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 10;
                    i{
                        position: absolute;
                        top: 405px;
                        left: 50%;
                        transform: translate(-50%,0);
                        color: #58effa;
                        font-size: 20px;
                    }
                }
                .bigvideo_box{
                    padding: 9px 17px;
                    width: 1181px;
                    height: 662px;
                    overflow: hidden;
                    .bigvideo_control{
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 12;
                        i{
                            background: url(https://www1.pcauto.com.cn/test/gz20200018/jizhi/img/play_btn.png) no-repeat center;
                            width:100px;
                            height: 100px;
                            background-size: 100px;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%,-50%);
                            cursor: pointer;
                        }
                    }
                    video{
                        width:1191px;
                    }
                }
                
            }
            .module_score{
                margin-top: 50px;
                .main_score{
                    border-bottom: 1px solid #123266;
                    padding-bottom: 30px;
                    .left_name{
                        font-size: 50px;
                    }
                    .right_score{
                        font-size: 32px;
                        color: #379cae;
                        i{
                            font-size: 80px;
                            color: #fff;
                        }
                    }
                }
                .sub_score{
                    position: relative;
                    .el-collapse{
                        border-top: 0;
                        border-bottom: 0;
                        .el-collapse-item{
                            border-bottom: 1px solid #123266;
                            .el-collapse-item__header{
                                background-color: transparent;
                                background: transparent;
                                font-size: 32px;
                                color: #fff;
                                border-bottom: 0;
                                line-height: 130px;
                                height: 130px;
                                .el-collapse-item__arrow{
                                    font-size: 20px;
                                }
                            }
                            .el-collapse-item__wrap{
                                background-color: #0b245c;
                                padding: 20px;
                                margin-bottom: 20px;
                                border-bottom: 0;
                                
                            }
                        }
                        
                    }
                    .sub_score_box{
                        position: relative;
                        .sub_allscore{
                            position: absolute;
                            top: 42px;
                            right: 50px;
                            color: #fff;
                            font-size: 24px;
                            color:#379cae;
                            i{
                                font-size: 32px;
                                color:#fff;
                            }
                        }
                        .sub_score_item{
                            font-size: 20px;
                            color: #fff;
                            line-height: 50px;
                            height: 50px;
                            .right_score{
                                font-size: 20px;
                                color:#379cae;
                                i{
                                    color:#fff;
                                }
                            }
                        }
                    }
                    
                }
            }
        }
        .bottom_flag{
            text-align: center;
            color: #1f5093;
            margin-top: 30px;
        }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/detail.vue